import { isNonEmpty } from '@sgme/fp';
import type { IntlKey } from 'locales';
import { ChangeEvent, FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { getAssetTypeFilters } from 'state/productsReferential/productsReferential.selectors';
import type { AppState } from 'state/state.model';
import { workspaceProductSelectorFilterSelected } from 'state/workspaces/workspaces/workspace.actions';
import type { WorkspaceWithProductSelector } from 'state/workspaces/workspaces/workspaces.model';
import { getActivatedAssetTypeFilter } from 'state/workspaces/workspaces/workspaces.selector';

interface ProductFilterProps {
  workspace: WorkspaceWithProductSelector;
}

export const ProductFilters: FC<ProductFilterProps> = ({ workspace }) => {
  const availableAssetTypeFilters = useSelector((state: AppState) => getAssetTypeFilters(state)) ?? [];
  const activatedAssetTypeFilter = useSelector((state: AppState) => getActivatedAssetTypeFilter(state, workspace));
  const dispatch = useDispatch();
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(workspaceProductSelectorFilterSelected(workspace, e.target.id));
    },
    [dispatch, workspace],
  );
  const isAssetTypeFiltersAvailable = isNonEmpty(availableAssetTypeFilters);
  return (
    isAssetTypeFiltersAvailable && (
      <div className="d-flex border-bottom border-1 border-start border-end">
        <form className="d-flex p-2 m-0 gap-1 fw-semibold">
          <fieldset>
            <span className="fw-normal mx-2">
              <FormattedMessage id="productSelector.assetTypes.label" />
            </span>
            {['All', ...availableAssetTypeFilters].map(assetType => (
              <div key={assetType} className="form-check form-check-inline m-0">
                <input
                  className="form-check-input"
                  type="radio"
                  id={assetType}
                  name="productFilters"
                  checked={activatedAssetTypeFilter === assetType}
                  onChange={onChange}
                />
                <label className="form-check-label" htmlFor={assetType}>
                  <FormattedMessage id={`productSelector.assetTypes.${assetType}` as IntlKey} />
                </label>
              </div>
            ))}
          </fieldset>
        </form>
      </div>
    )
  );
};
